import { ITrackerContext } from 'com/didichuxing/tracker/context/ITrackerContext';
import { IEventReportor } from 'com/didichuxing/tracker/plugin/reportor/IEventReportor';
import { ITrackedEvent } from 'com/didichuxing/tracker/event/ITrackedEvent';
import JsonpEventReportor from 'com/didichuxing/tracker/plugin/reportor/JsonpEventReportor';
import BeaconEventReportor from 'com/didichuxing/tracker/plugin/reportor/BeaconEventReportor';
import PostEventReportor from 'com/didichuxing/tracker/plugin/reportor/PostEventReportor';

export default class SendStrategyChoice {

    /**
     * @override
     * @inheritDoc
     * @returns {IEventReportor}
     */
    public static switchSendStrategy(context: ITrackerContext, event: ITrackedEvent) {
        if (navigator.sendBeacon) {
            // 第一优先级sendBeacon
            return new PostEventReportor(context, event);
            // return new BeaconEventReportor(context, event);
        // } else if (event.serialize().length < 1500) {
        //     // 第二优先级JSONP 可以阻塞 保证发送成功 但因为长度get请求问题长度限制可能无法成功，所以对长度做了限制
        //     return new JsonpEventReportor(context, event);
        } else {
            return new PostEventReportor(context, event);
        }
    }
}
